<template>
  <transition name="message-fade">
    <div v-if="isVisible" class="message-popup-overlay" @click="hide">
      <div class="message-popup" :class="typeClass" @click.stop>
        <div class="message-text">{{ message }}</div>
        <button class="message-close" @click="hide">×</button>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'MessagePopup',
  data() {
    return {
      isVisible: false,
      message: '',
      type: 'info',
      timer: null
    }
  },
  computed: {
    typeClass() {
      return `message-${this.type}`
    }
  },
  methods: {
    show(payload = {}) {
      const { message, type, duration } = payload
      this.message = message || ''
      this.type = type || 'info'
      this.isVisible = true
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      const timeout = typeof duration === 'number' ? duration : 2000
      if (timeout > 0) {
        this.timer = setTimeout(() => {
          this.isVisible = false
        }, timeout)
      }
    },
    hide() {
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      this.isVisible = false
    }
  },
  beforeDestroy() {
    if (this.timer) {
      clearTimeout(this.timer)
      this.timer = null
    }
  }
}
</script>

<style scoped>
.message-popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.25);
}

.message-popup {
  min-width: 320rem;
  max-width: 320rem;
  padding: 20rem 48rem 20rem 24rem;
  background: #fff;
  border: 1rem solid #000;
  box-shadow: 0 10rem 30rem rgba(0, 0, 0, 0.15);
  position: relative;
  font-family: 'Bespoke Serif', serif;
  color: #000;
   word-break: break-word;   /* 允许长单词换行 */
    white-space: normal;      /* 正常换行 */
}

.message-text {
  font-size: 16rem;
  line-height: 1.4;
}

.message-close {
  position: absolute;
  top: 10rem;
  right: 12rem;
  background: none;
  border: none;
  font-size: 20rem;
  cursor: pointer;
  color: #000;
}



.message-fade-enter-active,
.message-fade-leave-active {
  transition: opacity 0.2s ease;
}

.message-fade-enter,
.message-fade-leave-to {
  opacity: 0;
}
</style>
